import { render, staticRenderFns } from "./WorkspaceSettingIcon.vue?vue&type=template&id=595feaf9"
import script from "./WorkspaceSettingIcon.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports